<script lang="ts">
  import LogoIcon from "./assets/images/logo.icon.svg";

  import { isWidgetOpen } from "./store";

  function openChat() {
    isWidgetOpen.set(true);
  }
</script>

<button on:click={openChat} class="concierge-chat-widget-button">
  <img src={LogoIcon} alt="" />
</button>

<style>
  .concierge-chat-widget-button {
    height: 50px;
    width: 50px;
    background-color: #0e3c26;
    border-radius: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    z-index: 1;
    position: fixed;
    right: 20px;
    bottom: 20px;
  }
  .concierge-chat-widget-button > img {
    width: 35px;
    height: 35px;
    /* animation: slow-rotate 6s infinite; */
  }
  @keyframes slow-rotate {
    0% {
      transform: rotate(0deg);
      animation-timing-function: cubic-bezier(0.67, 0.09, 0.92, 0.49);
    }

    10% {
      transform: rotate(180deg);
      animation-timing-function: cubic-bezier(0.14, 0.81, 0.5, 0.97);
    }
    20% {
      transform: rotate(450deg);
      animation-timing-function: cubic-bezier(0.14, 0.81, 0.5, 0.97);
    }
    25% {
      transform: rotate(360deg);
      animation-timing-function: cubic-bezier(0.67, 0.09, 0.92, 0.49);
    }

    100% {
      transform: rotate(360deg);
    }
  }
</style>
